//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"Dispose",{},0,0],[["count"],"GetInProcessBodies",{R_:{inProcessBody:"TaggedObject[]"}},0,0],[[],"GetNumberOfInProcessBodies",{R_:{count:''}},0,0],[[],"GetAmFeatureBody",{R_:{amFeatureBody:"TaggedObject"}},0,0],[["count"],"GetAmFeatureBodies",{R_:{amFeatureBodies:"Body[]"}},0,0],[["count"],"GetMergedOperations",{R_:{mergedOprs:"CAM.Operation[]"}},0,0]],[]];
SPLM.CAM.PathLaserGeometryData = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.PathLaserGeometryData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;